// libs
// Utils
import {
    API_FETCH_CHAREGEBACK_DETAILS,
    API_FETCH_CHARGEBACK_DATA,
    API_VALIDATE_CHARGEBACK,
    API_RAISE_CHARGEBACK,
    API_CHARGEBACK_AGENT_ACTION,
    API_CHARGEBACK_MERCHANT_ACTION,
    API_GENERATE_REPORT,
    API_GET_ACTIVE_REPORT_CHARGEBACK,
    API_DOWNLOAD_REPORT,
    API_REFUND_DISPUTE,
    API_CHECK_DISPUTE_STATUS
} from 'utils/API/apiUrls';

import { apiStatusCodes } from 'utils/API/apiStatusCodes';
import { POST, GET } from '../../../utils/fetchWrappers';



// actions
import * as loaderActions from '../../../redux/common/loader/loader.actions';
import * as chargebackActions from './chargeback.actions';

// constants
import {
    CHARGEBACK_AGENT_ACTION_REQUEST,
    FETCH_CHARGEBACK_DATA_REQUEST,
    FETCH_CHARGEBACK_DETAILS_REQUEST,
    RAISE_CHARGEBACK_REQUEST,
    VALIDATE_CHARGEBACK_REQUEST,
    CHARGEBACK_MERCHANT_ACTION_REQUEST,
    GENERATE_CHARGEBACK_REPORT_REQUEST,
    GET_ACTIVE_CHARGEBACK_REPORT_REQUEST,
    DOWNLOAD_CHARGEBACK_REPORT_REQUEST,
    REFUND_DISPUTE_REQUEST,
    CHECK_DISPUTE_STATUS_REQUEST
} from './chargeback.constants';
import moment from 'moment';

// Libs
import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

export function* fetchChargeBackList(actions) {
    //console.log("🚀 ~ function*fetchChargeBackList ~ actions:", actions)
    try {
        const { payload } = actions;
        let request = {
            paginationDetails: {
                pageNo: payload.pageNumber,
                pageSize: payload.pageSize,
            },
        };

        if (payload.filterData) {
            request = { ...request, ...payload.filterData };
            request.startDate = moment(request.startDate)
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
            request.endDate = moment(request.endDate)
                .startOf('day')
                .format('YYYY-MM-DD 23:59:59');

            if (payload.filterData.search) {
                request.criteria = {};
                if (payload.filterData.search.startsWith('CB')) {
                    request.criteria = {
                        type: 'CHARGEBACK_ID',
                        identifier: payload.filterData.search,
                    };
                } else {
                    request.criteria = {
                        identifier: payload.filterData.search,
                    };
                }
            }
        }

        const { data } = yield call(POST, API_FETCH_CHARGEBACK_DATA, request);

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            //console.log("data",data,data.statusCode,apiStatusCodes.SUCCESS);
            yield put(chargebackActions.fetchChargeBackDataSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                chargebackActions.fetchChargeBackDataFailure({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            chargebackActions.fetchChargeBackDataFailure({
                error: data,
            })
        );
    }
}

export function* fetchChargeBackDetails(actions) {
    try {
        const { type, payload } = actions;
        //console.log("🚀 ~ function*fetchChargeBackDetails ~ payload:", payload)
        const { data } = yield call(
            POST,
            API_FETCH_CHAREGEBACK_DETAILS,
            payload
        );

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(chargebackActions.fetchChargeBackDetailsSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                chargebackActions.fetchChargeBackDetailsFailure({
                    error: data,
                })
            );
        }
    } catch (response) {
        const { data } = response;
        yield put(
            chargebackActions.fetchChargeBackDetailsFailure({
                error: data,
            })
        );
    }
}


export function* validateChargeBack(actions) {
    try {
        const { payload } = actions;

        const { data } = yield call(POST, API_VALIDATE_CHARGEBACK, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(chargebackActions.validateChargeBackSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                chargebackActions.validateChargeBackFailure({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            chargebackActions.validateChargeBackFailure({
                error: data,
            })
        );
    }
}

export function* raiseChargeBack(actions) {
    try {
        const { payload } = actions;

        const requestData = { ...payload };

        requestData.reportedDate = moment(payload.reportedDate)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');

        const formdata = new FormData();

        const files = requestData.files || [];
        delete requestData.files;

        const dtoObject = new Blob(
            [
                JSON.stringify({
                    ...requestData,
                }),
            ],
            {
                type: 'application/json',
            }
        );

        formdata.append('data', dtoObject, '');

        files.forEach(file => {
            formdata.append('file', file);
        });

        const { data } = yield call(
            POST,
            API_RAISE_CHARGEBACK,
            formdata,
            {
                'Content-Type': 'multipart/form-data',
            },
            true
        );

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            toast.success(
                `Chargeback Rasied Successfully! ${files.length} files uploaded!`
            );
            yield put(chargebackActions.raiseChargeBackSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                chargebackActions.raiseChargeBackFailure({
                    error: data,
                })
            );
        }
    } catch (response) {
        const { data } = response;
        yield put(
            chargebackActions.raiseChargeBackFailure({
                error: data,
            })
        );
    }
}

export function* chargebackAgentAction(actions) {
    try {
        const { payload } = actions;

        const formdata = new FormData();

        const dtoObject = new Blob(
            [
                JSON.stringify({
                    ...payload.details,
                }),
            ],
            {
                type: 'application/json',
            }
        );

        formdata.append('data', dtoObject, '');

        if (payload.files && payload.files.length > 0) {
            payload.files.forEach(file => {
                formdata.append('file', file);
            });
        }

        const { data } = yield call(
            POST,
            API_CHARGEBACK_AGENT_ACTION,
            formdata,
            {
                'Content-Type': 'multipart/form-data',
            },
            true
        );

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(chargebackActions.chargeBackAgentActionSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                chargebackActions.chargeBackAgentActionFailure({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            chargebackActions.chargeBackAgentActionFailure({
                error: data,
            })
        );
    }
}

export function* chargebackMerchantAction(actions) {
    try {
        const { payload } = actions;

        const formdata = new FormData();

        const dtoObject = new Blob(
            [
                JSON.stringify({
                    ...payload.details,
                }),
            ],
            {
                type: 'application/json',
            }
        );

        formdata.append('data', dtoObject, '');

        if (payload.files && payload.files.length > 0) {
            payload.files.forEach(file => {
                formdata.append('file', file);
            });
        }

        const { data } = yield call(
            POST,
            API_CHARGEBACK_MERCHANT_ACTION,
            formdata,
            {
                'Content-Type': 'multipart/form-data',
            },
            true
        );

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(chargebackActions.chargeBackMerchantActionSuccess(data));
        } else if (data && data.errorMessage) {
            toast.error(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        toast.error(data.errorMessage);
        yield put(
            chargebackActions.chargeBackMerchantActionFailure({
                error: data,
            })
        );
    }
}

export function* generateChargebackReport(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const request = { ...payload };

        if (payload.startDate && payload.endDate) {
            request.startDateTime = moment(request.startDate)
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
            request.endDateTime = moment(request.endDate)
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss');

            delete request.startDate;
            delete request.endDate;
        }

        request.reportType = 'CB_REPORT';

        if (payload.search) {
            request.criteria = {};
            if (payload.search.startsWith('CB')) {
                request.referenceId = payload.search;
                request.cbIdentifierType = 'CHARGEBACK_ID';
            } else {
                request.referenceId = payload.search;
            }

            delete request.search;
            delete request.criteria;
        }

        if (payload.paymentType) {
            request.transactionModes = payload.paymentType;
            delete payload.paymentType;
            delete request.paymentType;
        }

        const { data } = yield call(POST, API_GENERATE_REPORT, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            toast.success(
                `${payload.reportFileName} is in process, please check status after some time`
            );
            yield put(chargebackActions.generateChargebackReportSuccess(data));
        } else if (data && data.errorMessage) {
            const errorMessage = data.errorMessage || '';
            yield put(
                chargebackActions.generateChargebackReportError({
                    error: errorMessage || '',
                })
            );
            if (errorMessage) {
                toast.error(errorMessage);
            }
        }
    } catch (response) {
        const { data } = response;
        const errorMessage = data.errorMessage || '';
        yield put(
            chargebackActions.generateChargebackReportError({
                error: errorMessage || '',
            })
        );
        if (errorMessage) {
            toast.error(errorMessage);
        }
    }
    yield put(loaderActions.hideLoader());
}

export function* getActiveChargebackReportDetails(actions) {
    const { hideLoader } = actions;
    if (!hideLoader) {
        yield put(loaderActions.showLoader());
    }
    try {
        const { data } = yield call(POST, API_GET_ACTIVE_REPORT_CHARGEBACK, {
            reportType: 'CB_REPORT',
        });
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(chargebackActions.getActiveChargebackReportSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                chargebackActions.getActiveChargebackReportError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;

        yield put(
            chargebackActions.getActiveChargebackReportError({
                error: data,
            })
        );
    }
    if (!hideLoader) {
        yield put(loaderActions.hideLoader());
    }
}

export function* downloadChargebackReportRequest(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const request = {
            requestId: payload.requestId,
            reportType: 'CB_REPORT',
        };
        const { data } = yield call(POST, API_DOWNLOAD_REPORT, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                chargebackActions.downloadChargebackReportSuccess(data.fileUrl)
            );
            if (data.fileUrl) {
                const link = document.createElement('a');
                link.href = data.fileUrl;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } else if (data && data.errorMessage) {
            yield put(
                chargebackActions.downloadChargebackReportError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            chargebackActions.downloadChargebackReportError({
                error: data,
            })
        );
    }
    yield put(loaderActions.hideLoader());
}

export function* checkDisputeStatus(actions) {
    try {
        const { payload } = actions;

        // let data = {
        //     statusCode: 'SPG-0000',
        //     status: 'CLOSED',
        //     errorMessage: '',
        // };

        const { data } = yield call(POST, API_CHECK_DISPUTE_STATUS, payload);

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(chargebackActions.fetchDisputeStatusSuccess(data));
            toast.success('Dispute status updated successfully!!');
        } else if (data && data.errorMessage) {
            yield put(
                chargebackActions.fetchDisputeStatusFailure({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;

        toast.error(
            data.errorMessage ? data.errorMessage : 'Something went wrong!!'
        );

        yield put(
            chargebackActions.fetchDisputeStatusFailure({
                error: data,
            })
        );
    }
}

export function* refundDispute(actions) {
    try {
        const { payload } = actions;

        //console.log(payload, "consoling payload");

        const { data } = yield call(POST, API_REFUND_DISPUTE, payload);

        if (data) {
            if (data.statusCode === apiStatusCodes.SUCCESS) {
                //console.log(data, "consoling inside success if");
                yield put(chargebackActions.fetchRefundDisputeSuccess(data));
                toast.success('Dispute update was successful!!');
            } else if (data.errorMessage || data.statusMessage) {
                // Consider using both `errorMessage` and `statusMessage`
                //console.log(data, "consoling inside error if");
                yield put(
                    chargebackActions.fetchRefundDisputeFailure({
                        error: data.errorMessage || data.statusMessage || 'Unknown error occurred',
                    })
                );
                toast.error(data.errorMessage || data.statusMessage || 'Something went wrong!!');
            } 
        }
    } 
    catch (error) {
        // Use error.response if available, otherwise fall back to error.message
        const errorMessage = error.response?.data?.errorMessage || error.message || 'Something went wrong!!';
        toast.error(errorMessage);
        yield put(
            chargebackActions.fetchRefundDisputeFailure({
                error: error.response?.data || error.message,
            })
        );
    }
}




// Update dispute 
// export function* refundDispute(actions) {
//     try {
//         const { payload } = actions;

//         console.log(payload ," consoling payload");

//         const { data } = yield call(POST, API_REFUND_DISPUTE, payload);

//         if (data && data.statusCode === apiStatusCodes.SUCCESS) {
//             console.log(data, "consoling inside if");
//             yield put(chargebackActions.fetchRefundDisputeSuccess(data));
//             toast.success('Dispute update was successfull!!');
//         } else if (data && data.errorMessage) {
//             console.log(data, "consoling inside else if");
//             yield put(
//                 chargebackActions.fetchRefundDisputeFailure({
//                     error: data.errorMessage,
//                 })
//             );
//         }
//     } 
//     catch ({ response }) {
//         const { data } = response;
//         toast.error(
//             data.errorMessage ? data.errorMessage : 'Something went wrong!!'
//         );
//         yield put(
//             chargebackActions.fetchRefundDisputeFailure({
//                 error: data,
//             })
//         );
//     }
// }

/**
 * WATCHER SAGA
 */
export function* chargeBackSaga() {
    yield takeLatest(FETCH_CHARGEBACK_DATA_REQUEST, fetchChargeBackList);
    yield takeLatest(FETCH_CHARGEBACK_DETAILS_REQUEST, fetchChargeBackDetails);
    yield takeLatest(VALIDATE_CHARGEBACK_REQUEST, validateChargeBack);
    yield takeLatest(RAISE_CHARGEBACK_REQUEST, raiseChargeBack);
    yield takeLatest(CHARGEBACK_AGENT_ACTION_REQUEST, chargebackAgentAction);
    yield takeLatest(
        CHARGEBACK_MERCHANT_ACTION_REQUEST,
        chargebackMerchantAction
    );
    yield takeLatest(
        GENERATE_CHARGEBACK_REPORT_REQUEST,
        generateChargebackReport
    );
    yield takeLatest(
        GET_ACTIVE_CHARGEBACK_REPORT_REQUEST,
        getActiveChargebackReportDetails
    );
    yield takeLatest(
        DOWNLOAD_CHARGEBACK_REPORT_REQUEST,
        downloadChargebackReportRequest
    );
    yield takeLatest(CHECK_DISPUTE_STATUS_REQUEST, checkDisputeStatus);
    yield takeLatest(REFUND_DISPUTE_REQUEST, refundDispute);
}
